import React from 'react';
import { translate } from "../../translate";

export default function Popup( props ) {
    let { id, title, footer } = props;
    
    if ( !!!id ) id = "myModal";
    // if ( !!show && id ) showPopup(id);
    // if ( !!!show && id ) hidePopup(id);


    // function showPopup(id) {
    //     console.log('showww', `#${id}`);
        
    //     window.jQuery(`#${id}`).modal({backdrop: false})
    // }

    // function hidePopup(id) {
    //     window.jQuery(`#${id}`).modal("hide")
    //     console.log('hideeee', `#${id}`);
    // }

    return (
        <div id={id} className={`modal fade`} role="dialog">
            <div className="modal-dialog">

                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className={`close`} data-dismiss="modal">&times;</button>
                        <h4 className="modal-title">{title || translate( "Confirmar" )}</h4>
                    </div>
                    <div className="modal-body">
                        {props.children}
                    </div>
                    {
                        !!!footer ? "" : (
                            <div className="modal-footer">
                                {footer}
                            </div>
                        )
                    }

                </div>

            </div>
        </div>


    )
}
